module.exports = __webpack_public_path__ + "static/media/sad-pablo.925fefb2.png";